<template>
  <NaviButtonDropdown
    label=""
    class="navi-button-notification"
    :should-mount-dropdown="true"
  >
    <template #label>
      <span
        v-if="uninspectedNotificationsCount"
        class="navi-button-notification-count"
      >
        {{ uninspectedNotificationsCount }}
      </span>
      <i class="navi-button-notification-icon icon-font-bell" />
      {{ props.label }}
    </template>

    <NaviNotificationList
      :has-uninspected-count="uninspectedNotificationsCount > 0"
      :reset-uninspected-count="resetUninspectedCount"
    />
  </NaviButtonDropdown>
</template>

<script setup>
import { ref } from 'vue'

import useUserStore from '@/modules/shared/store/useUserStore'

import NaviButtonDropdown from '../../NaviButtonDropdown.vue'

import NaviNotificationList from './NaviNotificationList.vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
})

const { currentUser } = useUserStore()
const uninspectedNotificationsCount = ref(currentUser.uninspectedNotificationsCount)
const resetUninspectedCount = () => {
  uninspectedNotificationsCount.value = 0
}
</script>

<style scoped lang="scss">
.navi-button-notification {
  :deep(.navi-button-dropdown-wrapper) {
    right: 0;
    left: unset;
  }
  :deep(.navi-button-dropdown-pointer) {
    right: 30px;
    left: unset;
  }

  & {
    padding: 21px 8px 15px;
  }
}
.navi-button-notification-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-right: 9px;
}

.navi-button-notification-count {
  position: absolute;
  top: 6px;
  left: -1px;
  border: 2px solid #fff;

  background: #D5332E;
  color: #fff;
  font-size: 11px;
  font-weight: normal;
  line-height: 150%;
  padding: 0 4px;
  text-align: center;
  border-radius: 6px;
}
</style>
